import React from "react";

const Technologies = () => {
  return (
    <>
      <section>
        <div className="st-height-b100 st-height-lg-b80"></div>
        <div className="container">
          <div className="st-section-heading st-style1 text-center">
            <h4 className="st-section-heading-title">TECHNOLOGIES</h4>
            <h2 className="st-section-heading-subtitle">TECHNOLOGIES</h2>
          </div>
          <div className="st-height-b25 st-height-lg-b25"></div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {[
              { icon: "fab fa-react", name: "React" },
              { icon: "fas fa-rocket", name: "Next.js" },
              { icon: "fas fa-paper-plane", name: "Postman" },
              { icon: "fab fa-vuejs", name: "Vue" },
              { icon: "fab fa-angular", name: "Angular" },
              { icon: "fas fa-database", name: "MongoDB" },
              { icon: "fas fa-database", name: "SQL" },
              { icon: "fab fa-php", name: "PHP" },
              { icon: "fab fa-node-js", name: "Express" },
              { icon: "fab fa-node-js", name: "Node.js" },
              { icon: "fab fa-github", name: "Git" },
              { icon: "fab fa-vercel", name: "Vercel" },
            ].map((tech, index) => (
              <div key={index} className="p-4 shadow-md rounded-lg text-center">
                <i className={`${tech.icon} text-indigo-600 text-3xl mb-2`} />
                <h3 className="text-lg font-semibold">{tech.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Technologies;
